/**
 * QR Card Generator - Generates styled QR code cards for download
 * Design: Purple background, location name, QR code in white container
 */

const CARD_WIDTH = 800;
const CARD_HEIGHT = 860;
const PURPLE = "#655dc6";
const RADIUS = 32;
const ARABIC_FONT_URL = "/fonts/IBMPlexSansArabic-Bold.ttf";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

async function loadArabicFont() {
  const font = new FontFace("IBMPlexSansArabic", `url(${ARABIC_FONT_URL})`);
  await font.load();
  document.fonts.add(font);
}

export async function downloadQrCard({
  qrBase64,
  name,
  floor,
  building,
  bottomTextAr = "امسح الرمز للإبلاغ عن مشكلة صيانة",
  bottomTextEn = "Scan to report a maintenance issue",
  bgColor = "#655dc6"
}) {
  await loadArabicFont();

  const canvas = document.createElement("canvas");
  canvas.width = CARD_WIDTH;
  canvas.height = CARD_HEIGHT;
  const ctx = canvas.getContext("2d");

  // Purple background with rounded corners
  roundRect(ctx, 0, 0, CARD_WIDTH, CARD_HEIGHT, RADIUS);
  ctx.fillStyle = bgColor;
  ctx.fill();

  // Brand name - LUCENT DENTAL CENTER
  ctx.fillStyle = "white";
  ctx.font = "600 28px 'Segoe UI', Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("LUCENT DENTAL CENTER", CARD_WIDTH / 2, 60);

  // Separator line
  ctx.strokeStyle = "rgba(255,255,255,0.4)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(CARD_WIDTH / 2 - 50, 80);
  ctx.lineTo(CARD_WIDTH / 2 + 50, 80);
  ctx.stroke();

  // Location name - IBM Plex Sans Arabic
  ctx.fillStyle = "white";
  ctx.font = "bold 44px 'IBMPlexSansArabic', 'Segoe UI', Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText(name || "", CARD_WIDTH / 2, 130);

  // Floor + Building details
  const details = [floor, building].filter(Boolean).join(" • ");
  if (details) {
    ctx.fillStyle = "rgba(255,255,255,0.8)";
    ctx.font = "26px 'IBMPlexSansArabic', 'Segoe UI', Arial, sans-serif";
    ctx.fillText(details, CARD_WIDTH / 2, 168);
  }

  // QR Code white container (moved down for spacing)
  const qrContainerSize = 440;
  const qrContainerX = (CARD_WIDTH - qrContainerSize) / 2;
  const qrContainerY = 240;
  roundRect(ctx, qrContainerX, qrContainerY, qrContainerSize, qrContainerSize, 24);
  ctx.fillStyle = "white";
  ctx.fill();

  // Load QR image and draw
  const qrImg = new Image();
  qrImg.onload = () => {
    const qrPadding = 24;
    const qrSize = qrContainerSize - qrPadding * 2;
    ctx.drawImage(qrImg, qrContainerX + qrPadding, qrContainerY + qrPadding, qrSize, qrSize);

    // Bottom text - Arabic (IBM Plex Sans Arabic)
    ctx.fillStyle = "rgba(255,255,255,0.75)";
    ctx.font = "22px 'IBMPlexSansArabic', 'Segoe UI', Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(bottomTextAr, CARD_WIDTH / 2, 730);

    // Bottom text - English
    ctx.fillStyle = "rgba(255,255,255,0.55)";
    ctx.font = "18px 'Segoe UI', Arial, sans-serif";
    ctx.fillText(bottomTextEn, CARD_WIDTH / 2, 760);

    // Download
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `qr-${name || "location"}.png`;
    link.click();
  };

  qrImg.onerror = () => {
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `qr-${name || "location"}.png`;
    link.click();
  };

  qrImg.src = `data:image/png;base64,${qrBase64}`;
}
